import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { rentalContractModel } from '~/entities/common/RentalContract'
import { usePermissions } from '~/entities/common/viewer'
import { CarAtWorkSubStatusEnum } from '~/shared/config/enums'
import { Button, IconButton } from '~/shared/ui/Buttons'
import { ClockSnoozeWhiteIcon, ClockSnoozeYellowIcon } from '~/shared/ui/Icons'
import { useModal } from '~/shared/ui/Modal'
import { SuspendModal } from './SuspendModal'

type RentalContractSuspendProps = {
  rentalContractId: UniqueId
  isButton?: boolean
  isIcon?: boolean
}

export const RentalContractSuspend = ({
  rentalContractId,
  isButton,
  isIcon,
}: RentalContractSuspendProps) => {
  const { t } = useTranslation()
  const { canRentalContractsSuspend } = usePermissions()

  const { isModalShow, closeModal, openModal } = useModal()
  const queryClient = useQueryClient()

  const handleSuspend = useCallback(
    async (reason: CarAtWorkSubStatusEnum) => {
      await rentalContractModel.suspendRentalContractFx({
        rentalContractId,
        reason,
      })
      await queryClient.invalidateQueries({
        queryKey: ['rental-contracts-list'],
      })
    },
    [queryClient, rentalContractId],
  )

  if (!canRentalContractsSuspend) return null

  return (
    <>
      <SuspendModal
        onOk={handleSuspend}
        onCancel={closeModal}
        isShow={isModalShow}
      />
      {isButton && (
        <Button
          variant='yellow'
          color='warning'
          startDecorator={<ClockSnoozeWhiteIcon />}
          onClick={openModal}
        >
          {t('button.suspend the contract')}
        </Button>
      )}
      {isIcon && (
        <IconButton
          tooltipProps={{ title: t('button.suspend the contract') }}
          onClick={openModal}
        >
          <ClockSnoozeYellowIcon />
        </IconButton>
      )}
    </>
  )
}
